<template>
  <div id="languageSelection" class="section">
    <h1 class="title">Select a Language</h1>
    <div class="card">
      <br />
      <a class="card-footer-item">
        <p class="control">
          <button class="button is-info" :class="{ 'is-loading': isLoadingTamil }" @click="sendRequest('Tamil')">Tamil</button>
        </p>
      </a>
      <a class="card-footer-item">
        <p class="control">
          <button class="button is-info" :class="{ 'is-loading': isLoadingEnglish }" @click="sendRequest('English')">English</button>
        </p>
      </a>
      <a class="card-footer-item">
        <p class="control">
          <button class="button is-info" :class="{ 'is-loading': isLoadingHindi }" @click="sendRequest('Hindi')">Hindi</button>
        </p>
      </a>
      <!-- <a class="card-footer-item">
        <p class="control">
          <button class="button is-info" :class="{ 'is-loading': isLoadingMarathi }" @click="sendRequest('Marathi')">Marathi</button>
        </p>
      </a> -->
      <br />
    </div>
    <br /><br />
  </div>
</template>

<script>
export default {
  name: 'languageSelection',
  data() {
    return {
      isLoadingEnglish: false,
      isLoadingTamil: false,
      isLoadingHindi: false,
      isLoadingMarathi: false,
    };
  },
  methods: {
    sendRequest(language) {
      if (language === 'English') {
        this.$router.push('consent-form-english');
        this.$temp.testId = 2;
      } else if (language === 'Hindi') {
        this.$router.push('consent-form-hindi');
        this.$temp.testId = 6;
      } else if (language === 'Marathi') {
        this.$router.push('consent-form-marathi');
        this.$temp.testId = 5;
      } else {
        this.$router.push('consent-form-tamil');
        this.$temp.testId = 3;
      }
    },
  },
  created() {
    window.scroll(0, 0);
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/LanguageSelection.vue